module.exports = __webpack_public_path__ + "img/59_5.85cfa6ee.png";